import React from 'react';
import I18n from 'i18n-js';
import { RCBanner } from '@reverbdotcom/cadence/components';
import BrandedLockIcon from '@reverbdotcom/cadence/images/brand/security-orange.svg';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from '../shared/url_helpers';

const PaypalShopLockedModeBanner = () => {
  return (
    <RCBanner
      content={
        <>
          <Translate
            tag="p"
            text="discovery.sellerDashboard.paypalLockedModeBanner.description"
          >
            <span className="weight-bold">
              <CoreLink
                target="_blank"
                to={Paths.shopPoliciesEdit.expand({})}
                className="alert-banner__text-link"
              >
                <Translate text="discovery.sellerDashboard.paypalLockedModeBanner.linkText" />
              </CoreLink>
            </span>
          </Translate>
        </>
      }
      cta={
        <CoreLink
          target="_blank"
          to={Paths.shopPoliciesEdit.expand({})}
        >
          <Translate text="discovery.sellerDashboard.paypalLockedModeBanner.ctaText" />
        </CoreLink>
      }
      ctaVariant="muted"
      fullBleed
      image={BrandedLockIcon}
      title={I18n.t('discovery.sellerDashboard.paypalLockedModeBanner.title')}
      theme="error"
    />
  );
};

export default PaypalShopLockedModeBanner;
